import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=1cc4a630&scoped=true&"
import script from "./OfferCard.vue?vue&type=script&lang=js&"
export * from "./OfferCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc4a630",
  null
  
)

export default component.exports